import styled from 'styled-components';

export const CardContainer = styled.div`
  background: #22272B;
  border-radius: 5px;
  box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
  padding: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
  position: relative;
  min-height: 32px;
  overflow: hidden;
  padding: 0; /* Default padding to 0 */
  
  &:hover {
    outline: 1px solid #fff;
  }

  &:hover .card-quick-actions__button { /* Target button by class on CardContainer hover */
    opacity: 1;
    visibility: visible;
  }
`;

export const CardCoverImage = styled.img`
  width: 100%;
  height: 130px;
  object-fit: cover;
  display: block;
  background-color: #2C333A; /* Placeholder color */
  /* margin-bottom removed, CardContent's padding will create space */
`;

export const CardContent = styled.div`
  padding: 8px;
`;

export const CardTitle = styled.div`
  font-size: 14px;
  color: #ddd;
  line-height: 1.4;
  word-wrap: break-word;
  margin-bottom: ${props => props.hasLabels ? '8px' : '0'};
  padding-right: 28px; /* Add padding to prevent overlap with the menu button */
`;

export const Labels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
`;

export const Label = styled.div`
    height: ${props => props.expanded ? '16px' : '8px'};
    min-width: ${props => props.expanded ? 'auto' : '40px'};
    border-radius: 4px;
    background-color: ${props => props.color};
    transition: all 0.1s ease;
    display: flex;
    align-items: center;
    padding: ${props => props.expanded ? '0 8px' : '0'};
    font-size: 11px;
    font-weight: 600;
    color: white;
    cursor: pointer;
    
    &:hover {
        opacity: 0.8;
    }
`;

export const LabelText = styled.span`
  opacity: ${props => props.expanded ? 1 : 0};
  transition: opacity 0.1s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ddd;
`;

export const CommentIcon = styled.span`
  display: inline-flex;
  align-items: center;
  
  &::before {
    content: '💬';
    font-size: 12px;
  }
`;

export const ChecklistIcon = styled.span`
  display: inline-flex;
  align-items: center;
  
  &::before {
    content: '✓';
    font-size: 12px;
  }
`;

export const AssigneeAvatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${props => props.src ? 'none' : '#2C333A'};
  background-image: ${props => props.src ? `url(${props.src})` : 'none'};
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #B6C2CF;
  font-weight: 500;
  font-size: 12px;
  position: relative;

  &:hover::after {
    content: '${props => props.title}';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: #282E33;
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 12px;
    white-space: nowrap;
    margin-bottom: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const CardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #5e6c84;
  font-size: 12px;
`;

export const DueDateBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
  background-color: ${props => props.color || '#DFE1E6'}; // Default background
  color: ${props => props.textColor || 'white'}; // Default text color, assuming dark badges mostly

  svg {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    fill: currentColor;
  }

  &.completed {
    text-decoration: line-through;
    background-color: #36B37E; // Specific green for completed
    color: white;
  }

  &.completed svg {
    // Potentially change icon color or use a checkmark icon instead
  }
`;
